export const prize = (
  <div className="">
    <p style={{fontSize:"1.7rem"}}>
      <strong>Volvo XC60 B5 (P) 250hj Plus Dark AT FWD </strong>
    </p>

  
 <div>
  <ul>
 <li>Värv: <i>Fusion Red</i> (725) </li>
 <li>Mootor: Bensiin B5</li>
 <li>Mootori kubatuur: 1969 cm3</li>
 <li>Mootori tippvõimsus: 184+10 kW (250+14 hj)</li>
 <li>Maksimaalne pöördemoment: 350+40 Nm</li>
 <li>Jõuülekanne: FWD 4-silidriline</li>
 <li>Mootoritüübi kirjeldus: KERS turbomootor</li>
 <li>Käigukasti tüüp: AT</li>
 <li>Kiirendus 0-100km/h: 6,9 s</li>
 <li>WLTP keskmine kütusekulu: 7,9-8,9 l/100 km</li>
 <li>WLTP CO2: 179-202 g/km</li>
 <li>Kõrgus: 1655 mm</li>
 <li>Pikkus: 4708 mm</li>
 <li>Laius peeglitega: 2117 mm</li>
 <li>Laius peegliteta: 1902 mm</li>
 <li>Teljevahe: 2865 mm</li>
 <li>Kliirens: 216 mm </li></ul>
 </div> <div>
 <h4>Juhiabid</h4><ul>
 <li>Reguleeritav kiiruspiirik </li>
 <li>Püsikiirushoidja </li>
 <li><i>City Safety</i> II aktiivturvalisuse süsteem (sisaldab suure looma tuvastust)</li>
 <li>Sõidurajalt kõrvalekaldumise hoiatussüsteem </li>
 <li>Nõlvaltstardiabi</li>
 <li>Mäest laskumise abi </li>
 <li>Libeda tee ja teel oleva ohu hoiatus</li>
 <li>Vihmasensor </li>
 <li><i>Start/stop</i> süsteem </li>
 <li><i>Dynamic</i> veermik</li>
 <li>Parkimisabi ees ja taga </li>
 <li>Tagumine parkimiskaamera </li>
 <li>Eestikeelne kasutusjuhend </li>
 <li>Digitaalne kasutusjuhend keskekraanil </li></ul>
 </div> <div>
 <h4>Välimus</h4><ul>
 <li>Kokkuklapitavad küljepeeglid </li>
 <li>LED esituled, pööramisfunktsioonita </li>
 <li>Pakiruumiluuk embleemideta </li>
 <li>Kerevärvi uksekäepidemed koos lombivalgustusega </li>
 <li>Musta värvi tahavaatepeeglid </li>
 <li>Kerevärvi põrkeraudade ääred ja koopakaared </li>
 <li><i>High Gloss</i> mustad dekoorliistud külgakendel </li>
 <li><i>Glossy Black</i> integreeritud katusereelingud </li>
 <li><i>Dark design</i> iluvõre </li></ul>
 </div> <div>
 <h4>Pagasiruum</h4><ul>
 <li>Rehviparanduskomplekt </li>
 <li>Elektriliselt juhitav tagaluuk (nupust ja puldist) </li>
 <li>Manuaalne pagasikate </li>
 <li>Metallist läveliist pagasiruumis</li>
 <li>Pagasivõrk </li>
 <li>12V pistikupesa pakiruumis</li></ul>
 </div> <div>
 <h4>Ohutus </h4><ul>
 <li>Adaptiivsed pidurituled – avariipidurduse puhul hoiatavad vilkuvad pidurituled teisi juhte </li>
 <li>SIPS turvapadjad </li>
 <li>Kaasreisija turvapadja sisse- ja väljalülitamine </li>
 <li>Isofix kinnitused tagaistmetel </li></ul>
 </div> <div>
 <h4>Interjöör</h4><ul>
 <li>Dekoorelementidega PU-nahast käigukang </li>
 <li>Hele lagi</li>
 <li>Dekoorelementidega nahkrool</li>
 <li><i>Driftwood</i> sisedekoorid </li>
 <li>Valgustusega peeglid päikesesirmides </li>
 <li>Pimestamisvastased peeglid sees ja väljas </li>
 <li>Musta värvi tekstiilmatid </li>
 <li>Metallist Volvo lävepakuliistud </li>
 <li><i>Ambient</i> sisevalgustuspakett </li></ul>
 </div> <div>
 <h4>Multimeedia</h4><ul>
 <li><i>Audio Sensus Connect High Performance</i> helisüsteem</li>
 <li>Multifunktsionaalne rool </li>
 <li>2x USB-C pistikud ees </li>
 <li>Bluetooth</li>
 <li><i>Active Noise Control</i> helisüsteem </li>
 <li>Digitaalsed teenused</li>
 <li>Liiklusmärkide tuvastamise süsteem </li>
 <li>Volvo Cars rakendus, sisaldab SOS nuppu </li>
 <li>DAB satelliitraadio </li>
 <li>Hääljuhtimine </li>
 <li>Juhtmevaba laadimine nutitelefonile koos <i>OnOff</i> nupuga </li>
 <li>12,3" <i>Full Graphical</i> näidikuteplokk </li>
 <li>Istmed</li>
 <li>Elektriliselt reguleeritav kaasreisija iste </li>
 <li>Elektriliselt reguleeritav mäludega juhiiste </li>
 <li>Elektriliselt allapööratavad tagumised peatoed</li>
 <li>Kaasreisija istme mälu </li>
 <li>Neljas suunas elektriliselt reguleeritav nimmetugi esiistmetel </li>
 <li>Manuaalselt allaklapitav tagaistme seljatugi </li>
 <li>Käetugi koos topsihoidjatega </li>
 <li>Esiistmete istmepatjade pikendused </li>
 <li>Kliimasüsteem</li>
 <li>Elektrooniline kliimaseade, 2 tsooni </li>
 <li>Õhupuhastussüsteem Multifilter 3 </li>
 <li>Niiskussensor </li>
 <li>Klaasipesurid <i>Wet Arms</i></li></ul>
 </div> <div>
 <h4>Turva</h4><ul>
 <li>Elektriline lapselukk tagaustel </li>
 <li>Võtmevaba sisenemine</li>
 <li>Veljed</li>
 <li>Rehvirõhu kontrollsüsteem </li>
 <li>19" 5 V-kodaraga <i>Black Diamond Cut</i> valuveljed </li></ul>
 </div> <div>
 <h4>Alarm</h4><ul>
 <li>ARK + ARK pakett + 24h Autoabi teenus </li></ul>
 </div>




  </div>
);
